<template>
  <div class="fixed z-50 bottom-4 right-4 flex flex-col items-end gap-3">
    <!-- Globo estilo historieta -->
    <transition name="fade-slide">
      <div v-if="showMessage"
        class="relative bg-white text-gray-900  px-4 py-3 rounded-xl max-w-xs text-sm comic-bubble">
        <button class="absolute !text-xs top-2 right-2 text-gray-500 hover:text-red-500" @click="showMessage = false"
          aria-label="Cerrar">
          <i class="pi pi-times"></i>
        </button>
        Estamos por aquí. Contáctanos si necesitas ayuda!
      </div>
    </transition>

    <!-- Botón de WhatsApp con animación si el globito está activo -->
    <a href="https://wa.me/+17865572744" target="_blank" rel="noopener noreferrer"
      class="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 flex items-center justify-center"
      :class="{ 'animate-pulse': showMessage }" aria-label="Contáctanos por WhatsApp">
      <!-- Icono de WhatsApp -->
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path
          d="M20.52 3.48A11.76 11.76 0 0012.1.01a12.03 12.03 0 00-6.74 2A11.8 11.8 0 00.88 12.02a11.8 11.8 0 001.67 6.08L.01 24l6.17-2.03a11.77 11.77 0 005.91 1.53h.01a11.8 11.8 0 0011.79-11.79c0-3.15-1.23-6.12-3.37-8.23zM12.1 21.5a9.46 9.46 0 01-4.84-1.33l-.35-.21-3.66 1.2 1.2-3.56-.23-.37A9.5 9.5 0 1121.6 12c0 5.24-4.26 9.5-9.5 9.5zm5.34-7.12c-.29-.15-1.7-.84-1.96-.94-.26-.1-.45-.15-.64.15-.19.3-.73.94-.89 1.13-.16.19-.33.22-.62.07-.3-.15-1.28-.47-2.44-1.5a9.13 9.13 0 01-1.7-2.1c-.18-.3-.02-.46.13-.61.13-.13.3-.33.45-.5.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.07-.15-.64-1.54-.88-2.1-.23-.56-.46-.48-.63-.49-.16 0-.35-.01-.54-.01s-.5.07-.76.36c-.26.3-1 1-.98 2.4s1.01 2.79 1.15 2.98c.15.19 1.99 3.2 4.83 4.49.68.3 1.2.47 1.61.6.68.22 1.3.19 1.8.11.55-.08 1.7-.7 1.94-1.38.24-.68.24-1.26.17-1.38-.07-.11-.26-.18-.55-.33z" />
      </svg>
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const showMessage = ref(false)

onMounted(() => {
  setTimeout(() => {
    showMessage.value = true

    // Reaparecer cada 10 minutos si fue cerrado
    setInterval(() => {
      if (!showMessage.value) {
        showMessage.value = true
      }
    }, 10 * 60 * 1000)
  }, 5 * 1000)
})
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Burbuja de historieta estilo comic */
.comic-bubble {
  position: relative;
  border: 1px solid #444;
  border-radius: 16px;
  background-color: white;
}

.comic-bubble::after {
  content: '';
  position: absolute;
  bottom: -10px;
  right: 20px;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: white;
  border-bottom: 0;
  margin-left: -10px;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 1));
}
</style>
